// dashboardHeroRingColor.js — re-exports shared member hero ring helpers

export {
  MEMBER_HERO_RING_DEFAULT_COLOR as DASHBOARD_HERO_RING_DEFAULT_COLOR,
  sanitizeMemberHeroRingHex as sanitizeDashboardHeroRingHex,
  resolveMemberHeroRingHex as resolveDashboardHeroRingHex,
  getMemberHeroRingBorderClass as getDashboardHeroRingBorderClass,
  getMemberHeroRingHaloClass as getDashboardHeroRingHaloClass,
} from '../../../../../utils/memberHeroRingColor';
